/**
 * Determines if a hex color is light or dark for text contrast
 * @param hexColor - Hex color string (e.g., '#2E5AAC')
 * @returns 'light' for dark text, 'dark' for light text
 */
export const getTextContrast = (hexColor: string): 'light' | 'dark' => {
  // Remove the # if present
  const hex = hexColor.replace('#', '');

  // Convert to RGB
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  // Calculate luminance using the formula from WCAG 2.1
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Return 'dark' for light backgrounds (use dark text), 'light' for dark backgrounds (use light text)
  return luminance > 0.5 ? 'dark' : 'light';
};

/**
 * Gets the appropriate text color class based on background color
 * @param hexColor - Hex color string
 * @returns Tailwind CSS class for text color
 */
export const getTextColorClass = (hexColor: string): string => {
  const contrast = getTextContrast(hexColor);
  return contrast === 'light' ? 'text-white' : 'text-gray-900';
};
